import _ from "lodash-es";
import moment from "moment";

export const dateFormat = 'YYYY-MM-DD';
export const dateTimeFormat = 'YYYY-MM-DD hh:mm:ss';
export const primeVueDateFormat = 'yy-mm-dd';

export function parseDateTime(date) {
    return date ? moment(date).format(dateTimeFormat) : null
}

export function parseDate(date) {
    return date ? moment(date).format(dateFormat) : null
}

export function today() {
    return moment().format(dateFormat)
}

const normalizeProgressValue = value => {
    const numericValue = Number(value)
    if (!Number.isFinite(numericValue)) {
        return 0
    }
    return _.clamp(numericValue, 0, 1)
}

export const progressColor = value => {
    const normalizedValue = normalizeProgressValue(value)
    let color
    const percentage = normalizedValue * 100

    if (percentage < 35) {
        color = '#cc0000'; // red
    } else if (percentage < 75) {
        color = '#ffa500'; // orange
    } else {
        color = '#00aa00'; // green
    }

    return color;
}

export const progressTooltip = (name, value) => {
    const contents = {
        digitalization: 'indicates how many of your activities are measurable, i.e. can be found in the data.',
        adherence_ratio: 'indicates which ratio of process instances and their activities found in the data conform with the defined business rule(s).',
        coverage: 'indicates how much of your process is under control, i.e. defined business rules.'
    }
    const normalizedValue = normalizeProgressValue(value)
    return `${_.startCase(name)}: ${parseInt(normalizedValue * 100)}% - ${contents[name]}`
}

export const getDocsLink = (path = '') => {
    const base = import.meta.env.VITE_SERVICE_IMAGE_TAG
        ? '/docs/'
        : 'http://localhost:8080/docs/';
    if (!path) {
        return base;
    }
    const normalized = path.startsWith('/') ? path.slice(1) : path;
    return `${base}${normalized}`;
}
